export default __webpack_public_path__ + "static/3-f6a51c98d4e4cddf9f4e95004bbbc519.jpeg";